import * as palette from 'pkg/config/palette';

import rgba from 'pkg/rgba';

export const medium = `0 3px 15px ${rgba(palette.black, 0.15)}`;

export const flat = `0 0 0 1px ${rgba(palette.black, 0.05)}, 0 1px 3px 0 ${rgba(
	palette.black,
	0.15
)}`;

export const cardHover = `0 4px 8px 3px ${rgba(palette.black, 0.1)}`;
